import React from 'react';

const PeopleIcon = ({ size = 24, ...props }) => (
  <svg
    width={size}
    height={(size * 22) / 24}
    viewBox='0 0 24 22'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path d='M24 13.7437L23.3954 16.4951L22.1842 22H19.4117L20.6209 16.4951H3.98369L4.58829 13.7437H24ZM1.39786e-08 22H2.77254L3.98174 16.4951H1.2092L1.39786e-08 22ZM20.8068 6.5534C20.0711 9.90291 16.8387 12.5282 13.4499 12.5282C11.728 12.5282 10.2312 11.8524 9.23528 10.6252C8.22958 9.38641 7.86956 7.69126 8.24719 5.97476C8.98288 2.62524 12.2152 0 15.6041 0C17.3259 0 18.8208 0.675728 19.8167 1.90291C20.8224 3.14175 21.1844 4.83689 20.8068 6.5534ZM17.684 3.60777C17.2183 3.03495 16.4787 2.71845 15.6041 2.71845C13.5223 2.71845 11.3797 4.47573 10.9239 6.5534C10.7204 7.47573 10.8789 8.31456 11.37 8.92039C11.8356 9.49321 12.5733 9.80971 13.4499 9.80971C15.5298 9.80971 17.6742 8.05243 18.1301 5.97476C18.3336 5.05243 18.1732 4.21165 17.684 3.60777Z' />
  </svg>
);

export default PeopleIcon;
